import { useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';

interface IncentivioLogo2Props {
  /** Overrides both logo fills (e.g. white on a dark/gradient surface). */
  color?: string;
}

const IncentivioLogo2 = ({ color }: IncentivioLogo2Props) => {
  const { t } = useTranslation();
  const theme = useTheme();

  const fill1 = color ?? theme.palette.primary.main;
  const fill2 = color ?? theme.palette.common.blue2;

  return (
    <svg
      viewBox="0 0 1007 227"
      stroke="transparent"
      fill="transparent"
      width="100%"
      height="100%"
      aria-label={t('IncentivioLogo.alt', { incentivio: 'Incentivio' })}
    >
      <path
        fill={fill1}
        d="m 88.23,101.12 c 0,17.93 0,34.85 0,51.77 0,5.67 -0.04,11.33 0.01,17 0.03,3.53 -1.54,5.18 -5.13,5.13 -15.07,-0.21 -13.07,1.85 -13.1,-12.34 -0.06,-29.16 -0.06,-58.33 0.05,-87.49 0.01,-3.2 -1.74,-7.39 2.9,-9.06 4.77,-1.72 11.56,0.22 14.4,3.89 9.6,12.37 19.16,24.76 28.75,37.14 8.34,10.77 16.69,21.53 25.63,33.07 0.11,-2.26 0.24,-3.64 0.25,-5.03 0.01,-20.67 0,-41.33 0.01,-62 0,-6.51 0.69,-7.19 7.13,-7.2 q 11.6,-0.03 11.6,11.51 c 0,29.83 0,59.66 0,89.49 0,7.47 -0.58,7.53 -7.84,8.16 -5.65,0.49 -8.73,-1.98 -11.89,-6.11 -16.76,-21.92 -33.75,-43.66 -50.66,-65.46 -0.46,-0.59 -0.97,-1.14 -2.11,-2.46 z"
        id="path2"
      />
      <path
        fill={fill1}
        d="m 463,141.68 c 0,-23.42 -0.08,-45.54 0.1,-67.65 0.02,-2.55 1.19,-7.12 2.31,-7.27 4.43,-0.62 9.09,-0.09 13.57,0.62 0.82,0.13 1.67,3.11 1.68,4.78 0.1,32.31 0.05,64.62 0.1,96.93 0,4.13 -1.65,5.68 -5.94,6.08 -6.07,0.56 -9.6,-1.86 -13.16,-6.56 -16.94,-22.38 -34.26,-44.48 -51.46,-66.67 -0.36,-0.46 -0.88,-0.8 -1.97,-1.76 0,4.35 0,7.93 0,11.51 0,18.99 -0.09,37.97 0.06,56.96 0.04,4.72 -1.62,6.54 -6.43,6.44 -11.86,-0.25 -10.88,1.09 -10.88,-10.62 0.01,-30.31 0,-60.62 0.02,-90.94 0,-2.72 -0.95,-6.66 2.65,-7.1 3.85,-0.48 7.98,0.63 11.87,1.53 1.15,0.27 1.93,2.17 2.85,3.36 17.12,22.11 34.24,44.22 51.37,66.33 0.8,1.03 1.63,2.03 3.26,4.04 z"
        id="path3"
      />
      <path
        fill={fill1}
        d="m 838.65,175 c -28.19,1.6 -56.18,-24.3 -54.91,-56.49 1.02,-25.75 22.92,-53.17 56.67,-52.61 29.57,0.49 54.2,24.78 54.26,54.62 0.07,32.4 -27.57,55.9 -56.02,54.49 z m -0.15,-15.97 c 20.15,0.71 38.25,-16.72 38.46,-37.95 0.21,-21.11 -17.38,-39.06 -37.95,-39.08 -20.25,-0.02 -37.94,17.92 -37.71,38.63 0.25,22.46 18.8,38.97 37.2,38.4 z"
        id="path4"
      />
      <path
        fill={fill1}
        d="m 312.45,82 v 30.86 c 6.28,0 12.38,0 18.48,0 9.83,0 19.65,0.12 29.48,-0.03 4.64,-0.07 6.63,1.69 6.57,6.47 -0.1,7.76 -0.97,9.47 -6.74,9.62 -7.16,0.19 -14.32,0.05 -21.48,0.05 -8.64,0 -17.28,0 -26.22,0 V 159 c 1.88,0 3.65,0 5.43,0 16.15,0 32.31,-0.13 48.46,0.15 2.44,0.04 6.53,1.59 6.93,3.18 0.88,3.46 0.11,7.45 -0.57,11.11 -0.14,0.76 -2.82,1.47 -4.33,1.48 -22.82,0.09 -45.63,0.02 -68.45,0.11 -3.61,0.01 -5.06,-1.32 -5.05,-4.98 0.07,-32.97 0.07,-65.95 0,-98.92 0,-3.58 1.45,-5.16 5.01,-5.16 22.82,0.03 45.63,0.02 68.45,0.02 3.63,0 5.43,1.64 5.6,5.43 0.44,9.7 -0.3,10.57 -10.04,10.57 -15.49,0 -30.98,0 -46.46,0 h -5.07 z"
        id="path5"
      />
      <path
        fill={fill1}
        d="m 175.15,120.97 c -0.37,-25.95 21.48,-50.78 47.9,-54.24 23.23,-3.04 47.64,9.27 57.43,29.19 2.26,4.61 1.42,6.99 -3.63,7.73 -5.98,0.88 -11.2,0.8 -15.51,-5.55 -9.2,-13.54 -27.47,-19.75 -44.04,-13.04 -14.69,5.94 -25.26,22.64 -23.9,38.1 1.55,17.73 14.22,32.95 30.53,35.65 15.6,2.59 28.35,-2.94 37.95,-15.48 3.92,-5.12 11.03,-7.08 17.06,-4.53 3.76,1.59 3.23,4.01 1.72,6.86 -7.41,13.93 -18.65,23.2 -33.8,27.57 -29.39,8.48 -58.63,-6.75 -68.17,-34.93 -1.88,-5.54 -2.39,-11.55 -3.54,-17.34 z"
        id="path6"
      />
      <path
        fill={fill1}
        d="m 685.41,146.37 c 10.38,-25.41 20.46,-50.09 30.55,-74.76 2.08,-5.09 12.62,-7.95 17.18,-4.68 2.95,2.12 1.68,4.67 0.67,7.15 -7.37,18.16 -14.76,36.32 -22.15,54.47 -5.57,13.69 -11.45,27.27 -16.57,41.13 -2.28,6.19 -6.72,5 -11.27,5.42 -4.58,0.42 -6.36,-1.79 -7.91,-5.61 -12.77,-31.58 -25.62,-63.14 -38.64,-94.62 -2.79,-6.74 -0.42,-9.34 6.27,-9 9.05,0.46 9.05,0.11 12.55,8.68 9.66,23.68 19.33,47.35 29.32,71.81 z"
        id="path7"
      />
      <path
        fill={fill1}
        d="m 533.99,82.01 c -11.1,0 -21.72,0.02 -32.35,0 -5.77,-0.02 -6.63,-0.91 -6.65,-6.62 0,-1.5 0.05,-3 -0.01,-4.5 -0.13,-3.33 1.46,-4.89 4.76,-4.89 28.48,0 56.97,0 85.45,0 5.63,0 5.69,3.87 5.64,7.94 -0.07,6.26 -1.16,7.95 -6.21,8.02 -9.99,0.15 -19.99,0.05 -29.98,0.05 -0.81,0 -1.62,0 -2.84,0 -0.09,2.02 -0.23,3.78 -0.23,5.53 -0.01,26.48 0,52.97 -0.01,79.45 0,7.48 -0.54,8.01 -7.82,8.02 -1.17,0 -2.35,-0.11 -3.5,0.02 -4.86,0.56 -6.33,-1.7 -6.31,-6.38 0.14,-28.64 0.07,-57.29 0.07,-86.64 z"
        id="path8"
      />
      <path
        fill={fill1}
        d="m 35,120 c 0,-15.98 0.11,-31.96 -0.07,-47.94 -0.05,-4.56 1.62,-6.16 6.12,-6.13 11.17,0.09 11.18,-0.05 11.18,11.29 0,30.13 0,60.26 0,90.39 0,7.02 -0.37,7.35 -7.34,7.39 -10.62,0.06 -9.92,0.68 -9.89,-10.06 0.04,-14.98 0.01,-29.96 0.01,-44.95 z"
        id="path9"
      />
      <path
        fill={fill1}
        d="m 605,120.71 c 0,-16.15 0.14,-32.3 -0.08,-48.44 -0.07,-4.84 1.73,-6.74 6.42,-6.29 1.48,0.14 3,0.11 4.49,0 4.72,-0.32 6.47,1.84 6.45,6.53 -0.11,32.13 -0.1,64.26 0,96.38 0.01,4.48 -1.64,6.25 -6.19,6.16 -12.1,-0.23 -11.1,1.18 -11.09,-10.91 0.02,-14.48 0,-28.96 0,-43.45 z"
        id="path10"
      />
      <path
        fill={fill1}
        d="m 751,120.65 c 0,-15.98 0,-31.96 0,-47.94 0,-6.3 0.42,-6.69 6.89,-6.71 q 10.33,-0.03 10.33,10.07 c 0,30.63 0,61.26 0,91.89 0,6.58 -0.49,7.01 -7.19,7.04 -10.67,0.05 -10.07,0.79 -10.04,-9.91 0.05,-14.82 0.01,-29.63 0.01,-44.45 z"
        id="path11"
      />
      <path
        fill={fill2}
        d="m 971.99,41.4 c 0,11.05 -9.36,20.44 -20.38,20.44 -10.92,0 -20.46,-9.56 -20.42,-20.48 0.04,-11.05 9.43,-20.38 20.47,-20.35 11.14,0.03 20.33,9.25 20.33,20.39 z m -20.4,-11.47 c -6.31,0 -11.43,5.07 -11.51,11.38 -0.07,6.3 5.49,11.76 11.85,11.63 6.24,-0.13 11.22,-5.38 11.13,-11.72 -0.09,-6.44 -5.02,-11.29 -11.47,-11.29 z"
        id="path12"
      />
      <path
        fill={fill2}
        d="m 927.92,99.09 c -9.63,-0.02 -17.45,-7.7 -17.64,-17.32 -0.19,-9.59 8.05,-17.83 17.77,-17.77 9.57,0.06 17.52,7.9 17.65,17.41 0.13,9.67 -7.95,17.71 -17.78,17.69 z m 8.91,-17.52 c -0.09,-4.85 -4.24,-8.79 -9.12,-8.65 -4.65,0.13 -8.6,4.13 -8.58,8.68 0.02,4.75 4.23,8.71 9.12,8.6 4.63,-0.11 8.66,-4.16 8.58,-8.63 z"
        id="path13"
      />
      <path
        fill={fill2}
        d="m 904.87,26.53 c 9.49,-0.05 17.47,7.83 17.59,17.37 0.13,9.66 -7.94,17.88 -17.6,17.94 -9.48,0.06 -17.81,-8.39 -17.67,-17.93 0.13,-9.39 8.21,-17.33 17.68,-17.38 z m -0.19,26.43 c 4.78,0.13 9,-3.94 9.07,-8.74 0.07,-4.38 -3.99,-8.7 -8.43,-8.97 -4.68,-0.29 -9.09,3.79 -9.26,8.55 -0.18,4.78 3.83,9.03 8.62,9.16 z"
        id="path14"
      />
    </svg>
  );
};
export default IncentivioLogo2;
